module.exports = __webpack_public_path__ + "static/media/pmv_yellow_circle.371dba39.svg";